import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialGroupContractApi = {
    getTrialGroupContractByTrialGroupId: (trialGroupId: number): Observable<Dtos.GetTrialGroupContractByTrialGroupIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupContractByTrialGroupId = new Dtos.GetTrialGroupContractByTrialGroupId();
        request.trialGroupId = trialGroupId;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupContractByTrialGroupIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupContractById: (id: number): Observable<Dtos.GetTrialGroupContractByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupContractById = new Dtos.GetTrialGroupContractById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupContractByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialGroupContract: (trialGroupContract: Dtos.TrialGroupContract): Observable<Dtos.SetTrialGroupContractResponse> => {

        let request: Dtos.SetTrialGroupContract = new Dtos.SetTrialGroupContract();

        request.trialGroupContract = trialGroupContract;

        // send request
        const response: Promise<Dtos.SetTrialGroupContractResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialGroupContract: (trialGroupId: number): Observable<Dtos.CreateTrialGroupContractResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialGroupContract = new Dtos.CreateTrialGroupContract();

        request.trialGroupId = trialGroupId;

        //Send request.
        const response: Promise<Dtos.CreateTrialGroupContractResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialGroupContract: (trialGroupContract: Dtos.TrialGroupContract): Observable<Dtos.ValidateTrialGroupContractResponse> => {

        let request: Dtos.ValidateTrialGroupContract = new Dtos.ValidateTrialGroupContract();

        request.trialGroupContract = trialGroupContract;

        // send request
        const response: Promise<Dtos.ValidateTrialGroupContractResponse> = client.post(request);

        return Observable.from(response);
    },
    deleteTrialGroupContract: (id: number): Observable<Dtos.DeleteTrialGroupContractResponse> => {
        //Create the request.
        let request: Dtos.DeleteTrialGroupContract = new Dtos.DeleteTrialGroupContract();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.DeleteTrialGroupContractResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
}